import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";

const Segment: IModel = {
  title: "segmenti",
  apiPath: "segmenti",
  forms: {
    "default": {
      fields: ["id", "cost_length", "cost_corr_factor", "time_corr_factor"]
    },
  },
  listViews: {
    "default": {
      fields: ["id"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "cost_length",
      source: "cost_length",
      ttoken: "route.cost_length",
      type: "numeric",
      readonly: true
    },
    {
      title: "cost_corr_factor",
      source: "cost_corr_factor",
      ttoken: "route.cost_corr_factor",
      type: "numeric",
      validation: {
        required: true
      }
    },
    {
      title: "time_corr_factor",
      source: "time_corr_factor",
      ttoken: "route.time_corr_factor",
      type: "numeric",
      validation: {
        required: true
      }
    },
  ]
}

export default Segment;
